// collection faq
let collection_faq = document.querySelector('.new-collection-faqs span');
if (collection_faq) {
  let faqArray = collection_faq.innerHTML.split(';');
  for (let i = 0; i < faqArray.length - 1; i++) {
    let parts = faqArray[i].replace(/<br>/gi, '').split(':');
    let question = parts[0].trim();
    let answer = parts[1].trim();

    let h2Elem = document.createElement('div');
    h2Elem.className = 'new-collection-faq-question';
    h2Elem.innerHTML = question;

    let spanElem = document.createElement('div');
    spanElem.className = 'new-collection-faq-answer';
    spanElem.innerHTML = answer;

    let faqBox = document.createElement('div');
    faqBox.className = 'new-collection-faq-box';
    faqBox.appendChild(h2Elem);
    faqBox.appendChild(spanElem);
    let container = document.querySelector('.new-collection-faq-frame');
    container.appendChild(faqBox);
  }

  let questions = document.querySelectorAll('.new-collection-faq-question');
  let answers = document.querySelectorAll('.new-collection-faq-answer');
  for (var i = 0; i < questions.length; i++) {
    (function (j) {
      questions[j].onclick = function () {
        if (questions[j].classList.contains('active')) {
          answers[j].classList.remove('active');
          questions[j].classList.remove('active');
        } else {
          questions[j].classList.add('active');
          answers[j].classList.add('active');
        }
      };
    })(i);
  }
}

function openModal(ele) {
  var modal = document.getElementById('myModal');
  var modalImg = document.getElementById('modalImage');

  modal.style.display = 'block';
  modalImg.srcset = ele.srcset;
}

function closeModal() {
  var modal = document.getElementById('myModal');
  modal.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function (event) {
  // 当文档的内容（DOM）加载完成后，执行下面的代码

  // 查找页面中所有带有类名 '.yg-view-more' 的按钮元素，赋值给变量 buttons
  const buttons = document.querySelectorAll('.yg-view-more');

  const buttons_show_less = document.querySelectorAll('.yg-view-less');

  // 遍历所有按钮，并为它们添加点击事件监听器
  buttons_show_less.forEach((loadLessButton) => {
    loadLessButton.addEventListener('click', (e) => {
      const showLessTarget = e.srcElement.closest('.yg-media-container');
      const show_more_btn = showLessTarget.querySelector('.yg-view-more');
      const allShoeLessProducts = showLessTarget.querySelectorAll(
        '.yg-media-video-item'
      );
      for (i = 6; i < allShoeLessProducts.length; i++) {
        allShoeLessProducts[i].classList.add('hidden');
      }
      loadLessButton.classList.add('hidden');
      show_more_btn.style.display = 'block';
    });
  });

  // 设置产品每次显示的数量为 6
  const productNumber = 6;
  const productNumbers = parseInt(productNumber);

  // 遍历所有按钮，并为它们添加点击事件监听器
  buttons.forEach((loadMoreButton) => {
    loadMoreButton.addEventListener('click', (e) => {
      // 当 "加载更多" 按钮被点击时执行以下代码

      // 获取当前点击事件所在元素的最近的祖先元素，且该祖先元素具有 '.yg-media-container' 类名
      const target = e.srcElement.closest('.yg-media-container');
      const btnTarget = e.srcElement.closest('.btn-container');

      const show_less_btn = btnTarget.querySelector('.yg-view-less');
      show_less_btn.classList.remove('hidden');
      // 获取已显示的产品数量
      const displayedProductsCount = target.querySelectorAll(
        '.yg-media-video-item:not(.hidden)'
      ).length;

      // 显示接下来四个产品（productNumbers 的值为 6）
      for (
        let i = displayedProductsCount;
        i < displayedProductsCount + productNumbers;
        i++
      ) {
        console.log(' productNumbers:', displayedProductsCount);

        // 查找目标元素中的第 i+1 个带有 '.yg-media-video-item' 类名的元素
        const product = target.querySelector(
          `.yg-media-video-item:nth-of-type(${i + 1})`
        );

        // 如果找到了符合条件的产品元素，则移除该元素的 'hidden' 类名，使其显示出来
        if (product) {
          product.classList.remove('hidden');
        } else {
          // 如果没有更多产品可显示，则隐藏“加载更多”按钮
          loadMoreButton.style.display = 'none';
          break;
        }
      }
    });
  });
});
